import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RiskDataService } from '../../../app/risk/services/RiskDataService';

@Injectable()
export class HasRiskAccess  {
    private router = inject(Router);
    private _riskDS = inject(RiskDataService);


    canActivate(): Observable<boolean> {
        return this._riskDS.hasAccess().pipe(map((hasAccess) => {
            if (!hasAccess) {
                this.router.navigateByUrl('start');
                return false;
            } else {
                return true;
            }
        }));
    }
}
